// extracted by mini-css-extract-plugin
export var emptyMessage = "promo-module--emptyMessage--415a4";
export var headline = "promo-module--headline--8cea3";
export var item = "promo-module--item--ee3f7";
export var itemFew = "promo-module--itemFew--97186";
export var itemList = "promo-module--itemList--75931";
export var itemListFew = "promo-module--itemListFew--8f97a";
export var promo = "promo-module--promo--fe10b";
export var selectbuttons = "promo-module--selectbuttons--5be5e";
export var subcopy = "promo-module--subcopy--b3c52";